import { render } from "./IntegrationList.vue?vue&type=template&id=31d37c1c"
import script from "./IntegrationList.vue?vue&type=script&lang=js"
export * from "./IntegrationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__